import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { AllConnectors } from "@/features/Connectors/AllConnectors";

const searchSchema = z.object({
  /** Seeds the catalog search, e.g. ?q=shopify from the Plan Event CTA
   * (FOG-2498). */
  q: z.string().optional(),
});

export const Route = createFileRoute("/_auth/settings/$siteId/connectors/all")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
});

function RouteComponent() {
  const { q } = Route.useSearch();
  return <AllConnectors initialSearchTerm={q} />;
}
